export enum DoughnutChartType {
    PaymentMethod = 'payment-method',
    CardScheme = 'card-scheme',
    Issuer = 'issuer'
}
